import { readFinishScheduled } from "../../../data/repository/scheduled.repository";

export const ReadFinishScheduledUseCase = async () => {
  try {
    const resp = await readFinishScheduled();
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
